var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowtieAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1213 14.1213C12.9497 15.2929 11.0503 15.2929 9.87868 14.1213C8.70711 12.9497 8.70711 11.0503 9.87868 9.87868C11.0503 8.70711 12.9497 8.70711 14.1213 9.87868C15.2929 11.0503 15.2929 12.9497 14.1213 14.1213Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6712 7.51215C10.6315 7.58786 9.61301 8.02322 8.81802 8.81821C8.0231 9.61314 7.58775 10.6315 7.51198 11.6711L3.19808 9.51416C1.87531 8.85277 1.58923 7.08985 2.63497 6.0441L6.0441 2.63497C7.08984 1.58923 8.85277 1.87531 9.51416 3.19808L11.6712 7.51215Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.329 16.4882C13.3687 16.4125 14.387 15.9771 15.182 15.1822C15.977 14.3872 16.4124 13.3687 16.4881 12.3289L20.8019 14.4858C22.1247 15.1472 22.4108 16.9102 21.365 17.9559L17.9559 21.365C16.9102 22.4108 15.1472 22.1247 14.4858 20.8019L12.329 16.4882Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowtieAlt3);
export default __webpack_public_path__ + "static/media/bowtie-alt-3.394a8bb1d3018bf6b00ca77989bce7c3.svg";
export { ForwardRef as ReactComponent };